import type * as MantineTypes from '@mantine/core'
import { Switch } from '@mantine/core'
import type { PolymorphicComponentProps } from '@mantine/utils'
import { colors } from 'settings/colors'
import { useScreenSize } from 'utils/useScreenSize'

type MantineSwitchProps = PolymorphicComponentProps<'switch', MantineTypes.SwitchProps>

export const SectionTitleBarSwitch = ({ checked, ...MantineSwitchProps }: MantineSwitchProps) => {
  const { isWideScreen } = useScreenSize()

  return (
    <Switch
      css={{ cursor: 'pointer' }}
      size={isWideScreen ? 'sm' : 'md'}
      checked={checked}
      styles={{
        track: {
          cursor: 'unset',
          backgroundColor: checked ? `${colors.green} !important` : colors.grey500,
          borderColor: checked ? `${colors.green} !important` : colors.grey500,
        },
      }}
      {...MantineSwitchProps}
    ></Switch>
  )
}
